import { render, staticRenderFns } from "./EducationIcon.vue?vue&type=template&id=124b40b7&"
import script from "./EducationIcon.vue?vue&type=script&lang=js&"
export * from "./EducationIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports